export default class Accordion {
	constructor( domNode ) {
		this.rootEl = domNode;
		this.buttonEl = this.rootEl.querySelector( 'button[aria-expanded]' );

		const controlsId = this.buttonEl.getAttribute( 'aria-controls' );
		this.contentEl = document.getElementById( controlsId );

		if ( this.contentEl.classList.contains('show') ) {
			this.contentEl.style.maxHeight = this.contentEl.scrollHeight + 'px';
		}

		this.open = this.buttonEl.getAttribute('aria-expanded') === 'true';

		this.buttonEl.addEventListener( 'click', this.onButtonClick.bind( this ) );
	}

	onButtonClick() {
		this.toggle( ! this.open );
	}

	toggle( open ) {
		const children = this.rootEl.parentNode.children;
		for (let child of children) {
			const button = child.querySelector('button');
			if ( button ) {
				if ( button === this.buttonEl ) {
					const state = !(button.getAttribute('aria-expanded') === 'true');
					button.setAttribute( 'aria-expanded', `${state}`);
				} else {
					button.setAttribute( 'aria-expanded', 'false');
				}
			}

			if (child.tagName == "DIV") {
					if ( child === this.contentEl ) {
						const state = !child.classList.contains('show');
						if ( state ) {
							child.classList.add('show');
							child.style.maxHeight = child.scrollHeight + 'px';
						} else {
							child.classList.remove('show');
							child.removeAttribute('style');
						}
					} else {
						child.classList.remove('show');
						child.removeAttribute('style');
					}
			}
		}
	}

	// public open and close methods for convenience
	open() {
		this.toggle( true );
	}

	close() {
		this.toggle( false );
	}
}